module.exports = __webpack_public_path__ + "static/media/screenshot.7885429f.svg";